module.exports = __webpack_public_path__ + "static/img/volunteergiftsRecord.4a82338a.png";